import { ComponentVersions_3_0 } from 'constants/uxVersions'
import { ComponentVersionsInherit, Dialog, DialogCloseButton, DialogTitle, styled, Typography } from 'opensolar-ui'
import inflection from 'inflection'
import { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import { BulkEditDialogBody } from './BulkEditDialogBody'
import type { BulkEditDialogOpenPayload, BulkEditResourceDefinition } from './types'

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 2.5),
  boxSizing: 'border-box',
}))

type Props = {
  open: boolean
  session: BulkEditDialogOpenPayload | null
  onClose: () => void
  definition: BulkEditResourceDefinition
}

export const ListBulkEditDialog = ({ open, session, onClose, definition }: Props) => {
  const translate = useTranslate()
  const [blockCloseForAutoApply, setBlockCloseForAutoApply] = useState(false)

  useEffect(() => {
    if (!open) {
      setBlockCloseForAutoApply(false)
    }
  }, [open])

  if (!open || !session) {
    return null
  }

  const dialogTitle = translate(`resources.${session.resource}.name`, {
    smart_count: 1,
    _: inflection.humanize(inflection.singularize(session.resource)),
  })

  const handleDialogClose = () => {
    if (blockCloseForAutoApply) {
      return
    }
    onClose()
  }

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Dialog
        open={open}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
        id="bulk-edit-dialog"
        disableEscapeKeyDown={blockCloseForAutoApply}
      >
        <StyledDialogTitle>
          <Typography textVariant="h6SemiBold">{dialogTitle}</Typography>
          <DialogCloseButton onClick={handleDialogClose} disabled={blockCloseForAutoApply} />
        </StyledDialogTitle>
        <BulkEditDialogBody
          definition={definition}
          session={session}
          onClose={onClose}
          onAutoApplyBlockingChange={setBlockCloseForAutoApply}
        />
      </Dialog>
    </ComponentVersionsInherit>
  )
}
